/** @jsxImportSource @emotion/react */

import styled from "@emotion/styled";

import t from "../../../translations";

import CircularProgress from "@material-ui/core/CircularProgress";
import AddToCartIcon from "@material-ui/icons/AddShoppingCart";
import Button from "@material-ui/core/Button";

import { useStoreon } from "storeon/react";

const AddToCartButton = styled(Button)`
  svg {
    margin-right: 0px;
  }
  @media screen and (max-width: 480px) {
    font-size: 0px;
    min-width: 40px;
    padding: 6px;
    margin-right: 5px;
    svg {
      margin-right: 0px;
    }
  }
`;

const PrintfileDebugger = () => {
  const {
    product,
    dispatch,
    cachePool,
    contentType,
    contentId,
    canvas,
  } = useStoreon(
    "cachePool",
    "canvas",
    "isAdmin",
    "contentType",
    "contentId",
    "product"
  );

  const canvasObjects = canvas
    ?.getObjects()
    .filter((obj) => !obj.excludeFromExport);

  const isLoading = cachePool.length ? true : false;

  return (
    <AddToCartButton
      variant="contained"
      color="secondary"
      classes={{ text: "text" }}
      onClick={() => {
        if (isLoading) return;
        dispatch("preview/show");
        window._paq?.push([
          "trackEvent",
          "Cart",
          "Preview",
          product?.title,
          canvasObjects?.length,
        ]);
      }}
    >
      {isLoading ? (
        <CircularProgress
          size={24}
          style={{ marginRight: 5, color: "white" }}
        />
      ) : (
        <AddToCartIcon />
      )}
      {contentType === "orderItem" && "Update order"}
      {contentType !== "orderItem" &&
        (contentId && contentType === "cartItem" ? t.updateCart : t.addToCart)}
    </AddToCartButton>
  );
};

export default PrintfileDebugger;
